// @flow
export { default } from './Button';



// WEBPACK FOOTER //
// ./src/components/common/Button/index.js